/**
 *
 * @param el
 * @param binding
 * v-input.money 限制输入金额
 * v-input.int 限制输入整数
 * 可用于 input 或 el-input等输入框组件
 */
const vInput = {
  name: 'input',
  inserted(el, binding) {
    changeValue(el, binding);
  },
  unbind(el) {
    // 元素移除时卸载事件监听
    el.removeEventListener('input', el.handler);
  },
};

function changeValue(el, binding) {
  let inp = null;
  if (el.tagName.toLowerCase() === 'input') {
    inp = el;
  } else {
    inp = el.querySelector('input');
  }
  el.handler = function () {
    let realVal = inp.value;
    // 金额限制
    if (binding.modifiers.money) {
      realVal = limitMoney(inp.value.toString());
    }
    // 整数限制
    if (binding.modifiers.int) {
      realVal = limitInteger(inp.value.toString());
    }
    if (inp.value !== realVal) {
      inp.value = realVal;
      inp.dispatchEvent(new InputEvent('input', { data: realVal }));
    }
  };
  // 金额限制
  function limitMoney(value) {
    return value
      .replace(/[^\d.]/g, '')
      .replace(/\.{2,}/g, '.')
      .replace(/^0+/g, '0')
      .replace(/^0+\./g, '0.')
      .replace(/^0+\d/g, '0')
      .replace(/^(\d+)\.(\d\d).*$/, '$1.$2');
  }
  // 整数限制
  function limitInteger(value) {
    return value
      .replace(/[^\d]/g, '')
      .replace(/^0+/g, '0')
      .replace(/^0+\d/g, '0');
  }
  inp.addEventListener('input', el.handler);
}

export default vInput;
